export default {
  startingPitchers: {
    title: "Arremessadores titulares",
    tabs: {
      byPitcher: "Por arremessador",
      allPitchers: "Todos os arremessadores",
    },
    labels: {
      confirmed: "CONFIRMADO",
      expected: "ESPERADO",
      pitcher: "ARREMESSADOR",
      tbd: "A DEFINIR",
    },
    empty: {
      title: "Nenhum arremessador titular disponível",
    },
  },
};